/**
 * isiXhosa: Insights
 *
 * What this file covers: Chat insights: AI reports on a period's chats (what customers asked about, where chats stopped, what went unanswered, the next document to add, and advice on the chatbot, marketing and demand), their filters, downloads and the monthly report.
 *
 * Tone: Clear and encouraging, for business owners reading about their own customers. Say what a figure means in plain words; never promise more than the AI found, and be exact about what a report costs.
 *
 * isiXhosa: Everyday isiXhosa as used in South African business. Keys not translated yet fall back to English,
 * so a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const insights: Catalog = {
};

export default insights;
